
import Vue from 'vue';
import { CvToastNotification } from '@carbon/vue';
export default Vue.extend({
  name: 'Header',
  components: {
    CvToastNotification,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lowContrast: false,
      hideCloseButton: true,
    };
  },
});
